import { render, staticRenderFns } from "./ResellersTable.vue?vue&type=template&id=42d14bc8&scoped=true&lang=pug&"
import script from "./ResellersTable.vue?vue&type=script&lang=js&"
export * from "./ResellersTable.vue?vue&type=script&lang=js&"
import style0 from "./ResellersTable.vue?vue&type=style&index=0&id=42d14bc8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d14bc8",
  null
  
)

export default component.exports